var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tile is-parent"},[_c('article',{staticClass:"tile is-child box"},[_c('div',{staticClass:"subtitle"},[_vm._v("\n      "+_vm._s(_vm.name)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"is-flex"},[_c('figure',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.image,"alt":_vm.name}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-615e42fd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RequiredEquipment.vue
// module id = null
// module chunks = 